
// vue
import { defineComponent } from 'vue';

// atoms
import CustomButton from '@/components/atoms/CustomButton.vue';
import Heading from '@/components/atoms/Heading.vue';

export default defineComponent({
  name: 'ModalContent',
  components: {
    CustomButton,
    Heading,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
});
